import YearMonthInput from './YearMonthInput.component';

export default YearMonthInput;
